import React from 'react'

export const Bio = () => {
  return (
    <div className="text-center
                    sm:text-start">
    <h2 className="text-primary-white text-[2.5rem]">Nice to meet you! I'm <span className='underline'>Dominyk McNamara.</span></h2>
    <p className="text-primary-gray mt-[1.5rem]">Based in New Hampshire, United States, I'm a full stack developer passionate about building feature rich web apps that users love.</p>
    <a href="#contact" target="#" className="underline"><p className="text-primary-white hover:font-bold tracking-[0.143rem]  mt-[1.5rem]">Contact Me</p></a>
    </div>
  )
}
